import {
  extensionRegistry,
} from './registry'

interface ManifestModule {
  manifest?: unknown
}

/*
 * Genesis Extension Discovery
 *
 * Vite discovers extension manifests at build time.
 *
 * AppShell does not import individual plugins or widgets.
 *
 * Add:
 *   create folder + manifest.ts
 *
 * Remove:
 *   delete folder
 *
 * Registry validation decides whether the discovered
 * integration is accepted, disabled or rejected.
 */
export function discoverExtensions(): void {
  const pluginModules =
    import.meta.glob<ManifestModule>(
      '../../plugins/**/manifest.ts',
      {
        eager: true,
      },
    )

  const widgetModules =
    import.meta.glob<ManifestModule>(
      '../../widgets/**/manifest.ts',
      {
        eager: true,
      },
    )

  const discovered:
    ManifestModule[] = [
      ...Object.values(
        pluginModules,
      ),
      ...Object.values(
        widgetModules,
      ),
    ]

  for (
    const discoveredModule
    of discovered
  ) {
    extensionRegistry.register(
      discoveredModule.manifest,
    )
  }
}
